import { connect } from 'react-redux'
import PledgeSuccess from './pledge_success'

export default connect(state => ({
  geo: state.geo,
}))(PledgeSuccess)
